export default {
  local: "english",
  interactivity: {
    chapters: "Chapters",
    chapter: "Chapter",
    Poll: "POLL",
    yes: "Yes",
    no: "No",
    quiz: "QUIZ",
    dont_know: "I dont know",
    question: "QUESTION",
    sondage: "SURVEY",
    chaptersList: "List of chapters",
    attachment: "Attachments",
    downloadAll: "Download all",
    options: "Options",
  },
  player: {
    autoplay: "autoplay",
    audio: "Audio",
    auto: "Auto",
    buffered: "Buffered",
    captions: "Captions",
    currentTime: "Current time",
    slides: "Slides",
    duration: "Duration",
    enabled: "Enabled",
    enterFullscreen: "Enter fullscreen",
    enterPiP: "Miniplayer",
    exitFullscreen: "Exit fullscreen",
    fullscreen: "Fullscreen",
    live: "LIVE",
    loop: "Loop",
    mute: "Mute",
    none: "None",
    normal: "Normal",
    off: "Off",
    pause: "Pause",
    pip: "Picture-in-Picture",
    play: "Play",
    replay: "Replay",
    playback: "Playback",
    playbackQuality: "Playback Quality",
    playbackRate: "Playback Rate",
    played: "Played",
    scrubberLabel: "{currentTime} of {duration}",
    adjustVol: "Adjust volume",
    advance: "Advance",
    fastBackward: "Fast Backward",
    subtitleSetting: "Subtitle settings",
    offlineVideo: "The video is offline",
    liveVideoDesc: "The live has not started yet",
    srcprocessed: "The video source is being processed",
    videoPause: "Pause Video",
    link: "Link",
  },
  modals: {
    moreInfo: "more info",
    about: "ABOUT",
    quality: "Quality",
    rate: "SPEED",
    keyboardShortcuts: "KEYBOARD SHORTCUTS",
    showListOfShortcuts: "Show list of keyboard shortcuts",
    Closeallmodals: "Close all modals",
    default: "Default",
    disableCaptions: "Disable subtitles/captions",
    disabled: "Disabled",
    enableCaptions: "Enable subtitles/captions",
    functions: "Functions",
    shortcuts: "Shortcuts",
  },
  buttons: {
    send: "send",
    Continue: "CONTINUE",
    close: "Close",
    seekBackward: "Seek backward",
    seekForward: "Seek forward",
    settings: "Settings",
    subtitlesOrCc: "Subtitles/CC",
    unmute: "Unmute",
    volume: "Volume",
    confirm: "Confirm",
    rewind: "Rewind",
    next: "Next",
    download: "Download",
    disableSubtitles: "transcribed captions disabled",
    shareOn: "Share to",
    AD: "Audio/Description",
    ignore: "Ignore",
    valid: "Valid",
    rewindSec: "Rewind 10 sec",
    forwardSec: "Forward 10 sec",
    descPlayer: "Description",
    share: "Share",
  },
  AllTraslation: {
    searchChapter: "Search chapter",
    globalInfo: "General informations",
    socialMedia: "SOCIAL MEDIA",
    exportVideo: "EXPORT VIDEO",
    permalink: "permalink",
    copy: "copy",
    embedCode: "Embed Code",
    color: "Color",
    startAt: "start à",
    yourEmail: "Your email",
    receiverEmail: "Receiver email",
    message: "Message",
    emailExample: "example@example.com",
    writeYourMsg: "write your message",
    sendWithMail: "SEND WITH MAIL",
    spaceBar: "Spacebar",
    or: "or",
    seconds: "seconds",
    exitPiP: "Expand",
    scrubber: "Scrubber",
    seekTotal: "Seek total",
    video: "Video",
    viewport: "Viewport",
    resolution: "Current resolution",
    codec: "Codec",
    host: "Host",
    speed: "Connection Speed",
    repeat: "Repeat",
    statistics: "Statistics",
    powered: "Powered by ",
    continue: "Continue",
    authentication: "Authentication",
    textAuth: "You must enter the password to view this video",
    NotfoundPage: "Page not found",
    NotfoundPageDesc: "This page you are trying to view does not exist",
    AccessDenied: "Access Forbidden",
    AccessDeniedDesc: "The server refuses to execute this request",
    AuthRequired: "Authentification Required",
    NeedAuth: "Please authenticate to the platform to continue the video",
    shuffle: "Shuffle",
    playlist: "Playlist",
    searchPlaylist: "Search",
    viewPDF: "View the pdf",
  },
};
